import React from "react";
import {
  Typography,
  TypographyProps,
  Box,
  SxProps,
  Theme,
} from "@mui/material";

interface CustomLabelProps extends TypographyProps {
  text: string;
  fontWeight?: number | string;
  fontSize?: string | number;
  color?: string;
  highlightLabelStar?: boolean;
  center?: boolean;
  sx?: SxProps<Theme>;
}

const CustomLabel: React.FC<CustomLabelProps> = ({
  text,
  fontWeight,
  fontSize,
  color,
  highlightLabelStar = false,
  variant = "body1",
  center = false,
  sx,
  ...rest
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        width: center ? "100%" : undefined,
        justifyContent: center ? "center" : undefined,
      }}
    >
      <Typography
        variant={variant}
        sx={{
          fontWeight,
          fontSize,
          color,
          textAlign: center ? "center" : undefined,
          ...sx,
        }}
        {...rest}
      >
        {text}
      </Typography>
      {highlightLabelStar && (
        <Typography
          sx={{
            color: "red",
            fontWeight: "500",
            fontSize: "1rem",
            marginLeft: "4px",
          }}
        >
          *
        </Typography>
      )}
    </Box>
  );
};

export default CustomLabel;
